import allRoutes from '@/router/routes/all.js'
import publicRoutes from '@/router/routes/public.js'
import privateRoutes from '@/router/routes/private.js'
import projectRoutes from '@/router/routes/project.js'
import unitRoutes from '@/router/routes/unit.js'
import reportRoutes from '@/router/routes/report.js'
import settingRoutes from '@/router/routes/setting.js'
import profileRoutes from '@/router/routes/profile.js'
import invoiceRoutes from '@/router/routes/invoice.js'
import approvalRoutes from '@/router/routes/approval.js'

export default allRoutes.concat(
  publicRoutes, 
  privateRoutes, 
  projectRoutes, 
  unitRoutes, 
  reportRoutes, 
  settingRoutes,
  profileRoutes, 
  invoiceRoutes,
  approvalRoutes
)